import { useAppSelector } from '../../../Hooks/useAppSelector'
import { DelaysSelectors } from '../StoreAdapter'

export const useDelaysSelector = () => {
  return useAppSelector(DelaysSelectors.selectEntities)
}
